import React, { useState, useEffect } from 'react';
import { GamingService } from '../services/gaming';

const AchievementNotification = () => {
  const [achievements, setAchievements] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [lastCheck, setLastCheck] = useState(null);

  useEffect(() => {
    checkAchievements();
    const interval = setInterval(checkAchievements, 10000); // Check every 10s
    return () => clearInterval(interval);
  }, []);

  const checkAchievements = async () => {
    try {
      const myAchievements = await GamingService.getMyAchievements();
      
      // Check for new achievements
      if (lastCheck) {
        const newAchievements = myAchievements.filter(
          a => a.completed && new Date(a.completed_at) > lastCheck
        );
        
        if (newAchievements.length > 0) {
          // Get achievement details
          const allAchievements = await GamingService.getAchievements();
          const newNotifications = newAchievements.map(a => {
            const details = allAchievements.find(d => d.id === a.achievement_id);
            return { ...a, details };
          });
          
          setNotifications(prev => [...prev, ...newNotifications]);
        }
      }
      
      setAchievements(myAchievements);
      setLastCheck(new Date());
    } catch (error) {
      console.error('Error checking achievements:', error);
    }
  };

  const dismissNotification = (index) => {
    setNotifications(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="fixed top-20 right-4 z-50 space-y-3">
      {notifications.map((notification, index) => (
        <div
          key={index}
          className="bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 p-1 rounded-lg shadow-2xl animate-slide-in-right"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <div className="bg-gray-900 p-4 rounded-lg">
            <div className="flex items-start gap-3">
              <div className="text-4xl">
                {notification.details?.icon || '🏆'}
              </div>
              <div className="flex-1">
                <div className="text-yellow-400 font-bold text-lg mb-1">
                  Achievement Unlocked!
                </div>
                <div className="text-white font-bold">
                  {notification.details?.name}
                </div>
                <div className="text-gray-300 text-sm">
                  {notification.details?.description}
                </div>
                {notification.details && (
                  <div className="mt-2 flex items-center gap-3 text-xs">
                    <span className="text-green-400">
                      +{notification.details.reward_xp} XP
                    </span>
                    <span className="text-yellow-400">
                      +${notification.details.reward_currency}
                    </span>
                  </div>
                )}
              </div>
              <button
                onClick={() => dismissNotification(index)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AchievementNotification;